import { BlockActions } from "../../../shared/components/BlockActions/BlockActions";
import { BlockCommonContent } from "../../../shared/components/BlockCommonContent/BlockCommonContent";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { TextMediaRegion } from "../TextMediaRegion/TextMediaRegion";
import type { ITextMediaRtlProps } from "./TextMediaRtl.props";

export const TextMediaRtl = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  parentClass,
  spacing,
  video,
}: ITextMediaRtlProps) => {
  const hasCommonContent = Boolean(eyebrow || heading || description);
  const hasCopy = hasCommonContent || Boolean(buttons?.length);

  return (
    <BlockContainer anchorId={anchorId} parentClass={parentClass} spacing={spacing}>
      <div className="grid min-w-0 gap-10 lg:grid-cols-12 lg:items-center lg:gap-6">
        {hasCopy ? (
          <div className="min-w-0 lg:col-span-5">
            <BlockCommonContent
              alignment={alignment}
              description={description}
              eyebrow={eyebrow}
              heading={heading}
              headingLevel="h2"
            />
            <BlockActions
              actions={buttons ?? []}
              alignment={alignment}
              className={hasCommonContent ? "mt-8" : undefined}
            />
          </div>
        ) : null}
        <TextMediaRegion
          className={hasCopy ? "lg:col-span-7" : "lg:col-span-12"}
          image={image}
          title={heading}
          video={video}
        />
      </div>
    </BlockContainer>
  );
};

TextMediaRtl.displayName = "TextMedia::TextMediaRtl";
